var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.attributeType(),{tag:"component",attrs:{"attribute_group":_vm.attribute_item.attribute_group_item,"values":_vm.attribute_item.values,"read_only":_vm.read_only,"edit":_vm.edit,"modify":_vm.modify,"report_item_id":_vm.report_item_id}})
}
var staticRenderFns = []

export { render, staticRenderFns }